import React, { ReactElement } from 'react';

import { SectionBodyModel } from './sectionBody.model';

export const SectionBodyContainer = ({
  section,
}: SectionBodyModel): ReactElement => <>{section}</>;
